import { request } from "@/Api";
import { CustomRow } from "@/table/CustomTable";
import { Autocomplete, TableCell, TextField } from "@mui/material";
import { useState } from "react";
import { formattedCurrency } from "@/utils";
import { useDispatch } from "react-redux";
import { setError } from "@/nav/navSlice";

const AccountingBillLine = ({
    billLineData,
    bill,
    taxCodes,
    categories,
    hidden,
}) => {
    const dispatch = useDispatch();
    const [billLine, setBillLine] = useState(billLineData);
    const handleAutocompleteChange = (field) => (event, obj) => {
        const updatedBill = {
            ...billLine,
            [field]: obj.id,
        };
        setBillLine(updatedBill);
        request
            .patch(`/accounting-bill-lines/${billLine.id}/`, {
                [field]: obj.id,
            })
            .then((response) => {
                dispatch(
                    setError({ message: "Bill updated", severity: "success" }),
                );
            })
            .catch((err) => {
                dispatch(
                    setError({
                        message: JSON.stringify(err),
                        severity: "error",
                    }),
                );
            });
    };
    const handleNoteChange = (event) => {
        const val = event.target.value;
        if (val == billLine.description) {
            return;
        }
        const updatedBill = {
            ...billLine,
            description: val,
        };
        setBillLine(updatedBill);
        request
            .patch(`/accounting-bill-lines/${billLine.id}/`, {
                description: val,
            })
            .then((response) => {
                dispatch(
                    setError({
                        message: "Bill Note updated",
                        severity: "success",
                    }),
                );
            })
            .catch((err) => {
                dispatch(
                    setError({
                        message: JSON.stringify(err),
                        severity: "error",
                    }),
                );
            });
    };
    return (
        <>
            <CustomRow style={{ display: hidden ? "none" : "table-row" }}>
                <TableCell align="left" width={300}>
                    <div style={{ width: "100%" }}>
                        <Autocomplete
                            sx={{ minWidth: 200 }}
                            size="small"
                            defaultValue={billLine.accounting_account}
                            options={categories || []}
                            renderInput={(params) => (
                                <TextField
                                    fullWidth
                                    {...params}
                                    label="Category"
                                />
                            )}
                            onChange={handleAutocompleteChange(
                                "accounting_account_id",
                            )}
                            getOptionLabel={(option) => {
                                return option ? option.name : "";
                            }}
                            isOptionEqualToValue={(option, value) => {
                                if (!option || !value) {
                                    return true;
                                }
                                return option.id == value.id;
                            }}
                        />
                    </div>
                </TableCell>
                <TableCell align="left" width={"100%"}>
                    <TextField
                        fullWidth
                        size="small"
                        multiline
                        maxRows={2}
                        defaultValue={billLine.description}
                        onBlur={handleNoteChange}
                    />
                </TableCell>
                <TableCell align="right">
                    {formattedCurrency(
                        billLine.amount,
                        bill.currency,
                        false,
                        2,
                    )}
                </TableCell>
                <TableCell align="right">
                    {formattedCurrency(
                        billLine.actual_project,
                        bill.project_currency,
                        false,
                        2,
                    )}
                </TableCell>
                <TableCell align="left" width={300}>
                    <div style={{ width: "100%" }}>
                        <Autocomplete
                            sx={{ minWidth: 200 }}
                            size="small"
                            defaultValue={billLine.accounting_tax_code}
                            options={taxCodes || []}
                            renderInput={(params) => (
                                <TextField
                                    fullWidth
                                    {...params}
                                    label="Tax Code"
                                />
                            )}
                            onChange={handleAutocompleteChange(
                                "accounting_tax_code_id",
                            )}
                            getOptionLabel={(option) => {
                                return option ? option.name : "";
                            }}
                            isOptionEqualToValue={(option, value) => {
                                if (!option || !value) {
                                    return true;
                                }
                                return option.id == value.id;
                            }}
                        />
                    </div>
                </TableCell>
                {/* <TableCell align="right">
                    <AccountingBillLineActions />
                </TableCell> */}
            </CustomRow>
        </>
    );
};

export default AccountingBillLine;
